import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useFormContext } from 'react-hook-form';

import Checkbox from '@lib/inputs/Checkbox';
import { GridStyledWrapper } from '../voterRegistration.styled';

function VotingBallotTransferSection() {
    const { watch, setValue } = useFormContext();

    return (
        <div id="transferRequest-section">
            <FormattedMessage id="voterRegistration.form.votingBallotTransfer.header" tagName="h2" />

            <GridStyledWrapper>
                <div className="fullWidth margin-left-5">
                    <Checkbox
                        label={{
                            text: (
                                <FormattedMessage
                                    id="voterRegistration.form.votingBallotTransfer.transferRequest"
                                    values={{ strong: (chunks: any) => <strong>{chunks}</strong> }}
                                />
                            ),
                        }}
                        inputData={{
                            id: 'transferRequest',
                            name: 'transferRequest',
                            checked: watch('transferRequest'),
                            value: watch('transferRequest'),
                        }}
                        inputActions={{
                            handleFieldChange: val => {
                                setValue('transferRequest', val, {
                                    shouldValidate: true,
                                    shouldDirty: true,
                                });
                            },
                        }}
                    />
                </div>
            </GridStyledWrapper>
        </div>
    );
}

export default VotingBallotTransferSection;
